"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Item_1 = require("./Item");
var List_less_1 = __importDefault(require("./List.less"));
var List = function (_a) {
    var items = _a.items, loading = _a.loading, selected = _a.selected, monthInfo = _a.monthInfo, profile = _a.profile, onChange = _a.onChange;
    var filteredItems = (0, react_1.useMemo)(function () {
        return items.filter(function (_a) {
            var items = _a.items;
            return items.length;
        });
    }, [items]);
    return (react_1.default.createElement("div", { className: List_less_1.default['list'] }, items.length === 0 || loading ?
        [1, 2, 3].map(function (index) { return (react_1.default.createElement(Item_1.ItemPlaceholder, { key: index })); })
        :
            filteredItems.map(function (item) { return (react_1.default.createElement(Item_1.Item, __assign({ key: item.date.day }, item, { selected: selected, monthInfo: monthInfo, profile: profile, onClick: onChange }))); })));
};
exports.default = List;
